/**
 * Feed polling utility functions
 * Determines appropriate polling intervals based on environment configuration
 */

/**
 * Gets the appropriate polling interval for feed auto-refresh based on environment
 * @returns {number} Polling interval in milliseconds
 *   - 10 seconds (10000ms) for non-development environments
 *   - 30 seconds (30000ms) for development environment
 */
export const getFeedPollingInterval = () => {
  const environment = process.env.REACT_APP_ENVF;

  // Use 30 seconds for development to reduce network noise during development
  if (environment === 'env.development') {
    return 30000; // 30 seconds
  }

  // Use 10 seconds for production and other environments for faster updates
  return 10000; // 10 seconds
};

/**
 * Checks if feed auto-refresh should be enabled based on environment configuration
 * @returns {boolean} True if auto-refresh should be enabled
 */
export const isFeedAutoRefreshEnabled = () => {
  return process.env.REACT_APP_FEED_AUTOREFRESH === 'true';
};